<template>
  <div class="product-info">
    <h3 v-text="product.name" />
    <p>Story Count: {{ product.subTasks.length }}</p>
    <div class="progress-bar">
      <div class="progress-bar__product" :style="{ width: progress }" />
      <div class="progress-bar__bug" :style="{ width: bugStatus }" />
    </div>
    <p v-text="progress" />
    <button class="btn" @click="addStory(product)">Add Story</button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ProductInfo',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    progress() {
      return `${(this.product.progress * 100).toFixed(2)}%`;
    },
    bugStatus() {
      return `${(this.product.bugRatio * 100).toFixed(2)}%`;
    },
  },
  methods: {
    ...mapMutations(['addStory']),
  },
};
</script>

<style lang="less" scoped>
.product-info {
  width: 80%;
  padding: 10px 0;
  border: 1px solid #000;
  border-radius: 5px;
  & + & {
    margin-top: 10px;
  }
  .btn {
    width: 80%;
    padding: 5px;
    color: #fff;
    background-color: #BA5B3F;
  }
}

.progress-bar {
  position: relative;
  width: 80%;
  height: 20px;
  margin: 0 auto;
  background-color: #fff;
  border: 1px solid #d3d3d3;
  border-radius: 3px;
  > div {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: 1px;
    transition: width .5s;
  }
  + * {
    margin-top: 10px;
  }
  &__product {
    background-color: #BFD833;
  }
  &__bug {
    background-color: #F26B5B;
  }
}
</style>
